import { toBlob } from "html-to-image";

export type PartySharePngOptions = {
  fileNameBase: string;
};

export async function nodeToPngFile(node: HTMLElement, opts: PartySharePngOptions): Promise<File> {
  const blob =
    (await toBlob(node, {
      cacheBust: true,
      pixelRatio: 2,
      fetchRequestInit: { mode: "cors", credentials: "omit" },
    })) ?? null;
  if (!blob) throw new Error("Could not generate PNG blob");
  return new File([blob], `${opts.fileNameBase}.png`, { type: "image/png" });
}

export async function shareOrDownloadPng(file: File): Promise<void> {
  const canShareFiles =
    typeof navigator !== "undefined" &&
    typeof navigator.share === "function" &&
    typeof (navigator as unknown as { canShare?: (x: unknown) => boolean }).canShare === "function" &&
    (navigator as unknown as { canShare: (x: unknown) => boolean }).canShare({ files: [file] });

  if (canShareFiles) {
    await navigator.share({ files: [file] });
    return;
  }

  const url = URL.createObjectURL(file);
  try {
    const a = document.createElement("a");
    a.href = url;
    a.download = file.name;
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    URL.revokeObjectURL(url);
  }
}

